// extracted by mini-css-extract-plugin
export var chat = "styles-module--chat--f98f3";
export var container = "styles-module--container--d8c2d";
export var content = "styles-module--content--3b397";
export var contrastOverlay = "styles-module--contrastOverlay--661fb";
export var desktop = "1340px";
export var face = "styles-module--face--f5d39";
export var faceText = "styles-module--faceText--3ff10";
export var fadeGrow = "styles-module--fade-grow--a545a";
export var fadeIn = "styles-module--fade-in--c801a";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var leftColumn = "styles-module--leftColumn--2a14f";
export var mobile = "400px";
export var shopButton = "styles-module--shopButton--5d67f";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var spin = "styles-module--spin--98bf6";
export var tablet = "769px";
export var text = "styles-module--text--67e39";
export var textFlip3d = "styles-module--textFlip3d--13fe1";
export var visible = "styles-module--visible--8a965";